import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function SuggestionsProvider({ children }) {
  const [count, setCount] = useState(0);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/memory-suggestions");
      setCount((data.suggestions || []).length);
    } catch {}
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ count, refresh }}>{children}</Ctx.Provider>;
}

export const useSuggestions = () => useContext(Ctx) || { count: 0, refresh: () => {} };
